//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import moment from 'moment';
import ListView from './list-view.vue';
import {
  isoDateFormat,
  pastOrFuture,
} from '../time-utils.js';
import {logDashboardPerformance} from '../perf-utils.js'
import {getChildren, getBacklogItems} from '../reactive-cache.js';

function getSetting(key, default_value) {
  const value = JSON.parse(localStorage.getItem(key))
  return value === null ? default_value : value
}

const minFutureSections = {
  'days': getSetting('days-to-show', 2),
  'weeks': getSetting('weeks-to-show', 1),
  'months': getSetting('months-to-show', 1),
};

const minPastSections = {
  'days': 0,
  'weeks': 0,
  'months': 0,
};

export default {
  name: 'TimeBoard',
  data: function() {
    const now = moment();
    return {
      layoutId: 'calendar-view-layout',
      // TODO: schedule updating the day at midnight.
      // TODO: consider counting 'today' from 3 a.m. to 3 a.m.
      todayIso: now.clone().startOf('day').format(isoDateFormat),
      thisWeekIso: now.clone().startOf('isoWeek').format(isoDateFormat),
      thisMonthIso: now.clone().startOf('month').format(isoDateFormat),
      futureSectionsToShow: Object.assign({}, minFutureSections),
      pastSectionsToShow: Object.assign({}, minPastSections),
    };
  },
  components: {
    ListView,
  },
  computed: {
    layout() {
      const layoutDoc = this.$reactiveCache.docs[this.layoutId]
      if (!layoutDoc)
        return ['days', 'weeks', 'backlog']
      else
        return layoutDoc.layout.flat()
    },
    panels() {
      const result = []
      for (const key of this.layout) {
        if (['days', 'weeks', 'months', 'backlog'].includes(key)) {
          result.push(this.specialColumns[key]);
        } else {
          const section = this.getSection('plannedFor', 'list', key)
          section.title = this.$reactiveCache.docs[key]?.name;
          section.type = "current"
          result.push({
            key,
            icon: 'assignment',
            text: key,
            sections: [section],
          });
        }
      }
      return result;
    },
    specialColumns() {
      const result = {}

      const daysSections = this.allParentClassSections('day')
      if (this.$settings && this.$settings.showInbox) {
        const inbox = this.getSection('plannedFor', 'list', 'inbox')
        inbox.type = 'future'
        daysSections.unshift(inbox)
        const notatki = this.getSection('plannedFor', 'list', 'notatki')
        notatki.type = 'future'
        daysSections.unshift(notatki)
      }
      result['days'] = {
        key: 'days',
        icon: 'today',
        text: this.$gettext('Days'),
        sections: daysSections,
        navigation: true,
      }
      result['weeks'] = {
        key: 'weeks',
        icon: 'date_range',
        text: this.$gettext('Weeks'),
        sections: this.allParentClassSections('week'),
        navigation: true,
      }
      result['months'] = {
        key: 'months',
        icon: 'event_note',
        text: this.$gettext('Months'),
        sections: this.allParentClassSections('month'),
        navigation: true,
      }
      result['backlog'] = {
        key: 'backlog',
        icon: 'assignment',
        text: this.$gettext('Unplanned'),
        sections: this.backlogsPerTeam,
      }
      return result;
    },
    backlogsPerTeam() {
      if (!this.$reactiveCache) {
        return [];
      }
      const allTasks = getBacklogItems(this.$reactiveCache)
      const result = [];
      for (const couch of Object.values(this.$sessionState.dbs)) {
        const tasks = allTasks.filter(task => {
          return task.couch.name == couch.name
        })
        result.push({
          class: 'list',
          key: 'backlog',
          title: this.$gettext('Unplanned'),
          type: 'current',
          relation: 'plannedFor',
          tasks: tasks,
          couch: couch,
        });
      }
      return result;
    },
  },
  methods: {
    firstAndLastToShow(unit) {
      let nowMoment;
      switch (unit) {
        case 'day': nowMoment = moment(this.todayIso); break;
        case 'week': nowMoment = moment(this.thisWeekIso); break;
        case 'month': nowMoment = moment(this.thisMonthIso); break;
      }
      const firstKey =
          this.$reactiveCache.plannedFor[unit].$firstActivePendingKey;
      if (firstKey) {
        let timeAgo;
        switch (unit) {
          case 'day':
            timeAgo = moment.duration(nowMoment.diff(firstKey)).asDays()
            break;
          case 'week':
            timeAgo = moment.duration(nowMoment.diff(firstKey)).asWeeks()
            break;
          case 'month':
            timeAgo = moment.duration(nowMoment.diff(firstKey)).asMonths()
            break;
        }
        this.pastSectionsToShow[unit+'s'] = Math.max(
          timeAgo,
          this.pastSectionsToShow[unit+'s']
        );
      }
      return {
        firstMoment: nowMoment.clone()
          .subtract(this.pastSectionsToShow[unit+'s'], unit),
        lastMoment: nowMoment.clone()
          .add(this.futureSectionsToShow[unit+'s'], unit),
      }
    },
    getSection(relation, pClass, pKey) {
      if (!this.$reactiveCache) {
        return {};
      }
      const items = getChildren({cache: this.$reactiveCache, relation, pClass, pKey});

      const defaultDB = this.$settings && this.$settings.defaultDBname
        ? this.$sessionState.dbs[this.$settings.defaultDBname]
        : this.$defaultDB
      const result =  {
        relation: relation,
        class: pClass,
        key: pKey,
        tasks: items,
        couch: defaultDB,
      };
      if (relation === 'plannedFor' && pClass != 'list') {
        result.moment = moment(pKey);
        result.type = pastOrFuture(result.moment, pClass)
      } else {
        result.type = 'list'
      }
      return result;
    },
    allParentClassSections(unit) {
      const result = [];
      let emptyCount = -1;  // offset for first section which is always shown

      const {firstMoment, lastMoment} = this.firstAndLastToShow(unit);
      for (let startMoment = firstMoment.clone();
           startMoment.isSameOrBefore(lastMoment);
           startMoment.add(1, unit)) {
        const key = startMoment.format(isoDateFormat)
        const section = this.getSection('plannedFor', unit, key)

        // keep track of number of empty sections that will be omitted later.
        section.previousEmptySections = emptyCount;
        if (section.tasks.length) {
          emptyCount = 0;
        } else {
          emptyCount++;
        }

        result.push(section);
      }
      return result;
    },
    increaseProgressively(input, cap = 30) {
      // ~dobule the input, with cap and special handling for 0 and 1
      if (input == 0) {
        return 1;
      } else if (input == 1) {  // doubling 1 would feel too slow
        return 3;
      } else if (input < cap) {
        return input * 2;
      } else {
        return input + cap;
      }
    },
    showMore(data) {
      this.futureSectionsToShow[data.panelKey] =
        this.increaseProgressively(this.futureSectionsToShow[data.panelKey])
    },
    showPrevious(data) {
      this.pastSectionsToShow[data.panelKey] =
        this.increaseProgressively(this.pastSectionsToShow[data.panelKey])
    },
    resetMore(data) {
      this.futureSectionsToShow[data.panelKey] = minFutureSections[data.panelKey]
    },
    resetPrevious(data) {
      this.pastSectionsToShow[data.panelKey] = minPastSections[data.panelKey]
    },
  },
  created() {
    console.debug(performance.now().toFixed() + ': dashboard created');
    performance.mark('dashboard start')
    if (performance.getEntriesByName('cache-ready').length) {
      performance.measure('..1. cache -> dashboard', 'cache-ready', 'dashboard start');
    }
  },
  mounted() {
    console.debug(performance.now().toFixed() + ': dashboard mounted');
    performance.mark('dashboard end')
    logDashboardPerformance(this.$root)
  },
  beforeUpdate() {
    if(this.$root.debug) {
      console.debug('updating dashboard');
      performance.mark('start')
    }
  },
  updated() {
    if(this.$root.debug) {
      performance.mark('stop')
      const m = performance.measure('updating dashboard', 'start', 'stop');
      console.debug('dashboard updated:', m.duration.toFixed(), 'ms');
    }
  },
};
